/* mate Reviews (Design B): Reiter, Themen-Chips, Mehr laden, Foto-Wand, Lightbox. Kein Framework. */
(function () {
  'use strict';

  function fmt(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }

  function init(root) {
    if (!root || root.dataset.mrReady) return;
    root.dataset.mrReady = '1';

    var group = root.dataset.mrGroup;
    var fetchBase = root.dataset.mrFetch;
    var list = root.querySelector('[data-mr-list]');
    var more = root.querySelector('[data-mr-more]');
    var moreLabel = root.querySelector('[data-mr-more-label]');
    var status = root.querySelector('[data-mr-status]');
    var tabs = root.querySelectorAll('[data-mr-tab]');
    var state = { series: 'date', tab: 'date', filterLabel: '', filterSeries: '', page: 1, pageCount: 1, total: 0, shown: 0 };
    if (!list) return;

    function readInfo() {
      var infos = list.querySelectorAll('[data-mr-page-info]');
      var info = infos[infos.length - 1];
      if (info) {
        state.page = parseInt(info.dataset.page || '0', 10);
        state.pageCount = parseInt(info.dataset.pageCount || '0', 10);
        state.total = parseInt(info.dataset.total || '0', 10);
      }
      state.shown = list.querySelectorAll('.mr-card').length;
      root.querySelectorAll('[data-mr-series]').forEach(function (b) { b.setAttribute('aria-pressed', state.filterSeries && b.dataset.mrSeries === state.filterSeries ? 'true' : 'false'); });
      if (more) {
        more.hidden = !(state.page < state.pageCount);
        var rest = Math.max(state.total - state.shown, 0);
        if (moreLabel) moreLabel.textContent = 'Weitere ' + Math.min(12, rest) + ' von ' + fmt(state.total) + ' laden';
      }
      if (status) {
        if (state.filterLabel) {
          status.hidden = false;
          status.innerHTML = '';
          var txt = document.createElement('span');
          txt.textContent = fmt(state.total) + (state.total === 1 ? ' Bewertung ' : ' Bewertungen ') + state.filterLabel;
          var reset = document.createElement('button');
          reset.type = 'button'; reset.className = 'mr__reset'; reset.textContent = 'Filter aufheben';
          reset.addEventListener('click', function () { clearFilters(); load(state.tab, 1, true); });
          status.appendChild(txt); status.appendChild(reset);
        } else { status.hidden = true; }
      }
    }

    function load(series, page, replace) {
      var handle = group + '--' + series + '--' + page;
      if (more) more.classList.add('is-loading');
      if (replace) list.classList.add('is-loading');
      return fetch(fetchBase + encodeURIComponent(handle), { headers: { 'X-Requested-With': 'fetch' } })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html || html.indexOf('data-mr-page-info') === -1) return;
          if (replace) { list.innerHTML = html; }
          else {
            list.querySelectorAll('[data-mr-page-info]').forEach(function (n) { n.remove(); });
            list.insertAdjacentHTML('beforeend', html);
          }
          state.series = series;
          readInfo();
        })
        .catch(function () { /* alte Liste bleibt stehen */ })
        .then(function () { if (more) more.classList.remove('is-loading'); list.classList.remove('is-loading'); });
    }

    function clearFilters() {
      root.querySelectorAll('[data-mr-series]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      state.filterLabel = ''; state.filterSeries = '';
    }
    function selectTab(name) {
      tabs.forEach(function (t) { t.setAttribute('aria-selected', t.dataset.mrTab === name ? 'true' : 'false'); });
      state.tab = name;
    }
    function scrollToList() {
      var anchor = status && !status.hidden ? status : (root.querySelector('.mr__controls') || list);
      var y = anchor.getBoundingClientRect().top + window.pageYOffset - 120;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }

    if (more) more.addEventListener('click', function () { load(state.series, state.page + 1, false); });

    tabs.forEach(function (t) {
      t.addEventListener('click', function () { clearFilters(); selectTab(t.dataset.mrTab); load(t.dataset.mrTab, 1, true); });
    });

    root.addEventListener('click', function (e) {
      /* "+N Fotos" in der Foto-Wand → Reiter "Mit Fotos" */
      var jump = e.target.closest('[data-mr-tab-jump]');
      if (jump) { clearFilters(); selectTab(jump.dataset.mrTabJump); load(jump.dataset.mrTabJump, 1, true).then(scrollToList); return; }

      /* Themen-Filter: ein Filter aktiv, zweiter Klick hebt auf */
      var btn = e.target.closest('[data-mr-series]');
      if (!btn || btn.disabled) return;
      var series = btn.dataset.mrSeries;
      var wasOn = state.filterSeries === series;
      clearFilters();
      if (wasOn) { load(state.tab, 1, true); return; }
      state.filterSeries = series;
      state.filterLabel = btn.dataset.mrTopic ? 'zu „' + btn.dataset.mrTopic + '“' : '';
      load(series, 1, true).then(function () { if (window.matchMedia('(max-width: 760px)').matches) scrollToList(); });
    });

    /* Lightbox */
    var box = root.querySelector('[data-mr-lightbox]');
    var content = root.querySelector('[data-mr-lightbox-content]');
    var lastFocus = null;
    function closeBox() { if (!box) return; box.hidden = true; content.innerHTML = ''; document.body.style.overflow = ''; if (lastFocus) lastFocus.focus(); }
    root.addEventListener('click', function (e) {
      var item = e.target.closest('[data-mr-media]');
      if (!item || !box) return;
      lastFocus = item;
      var el = document.createElement(item.dataset.mrMediaType === 'video' ? 'video' : 'img');
      el.src = item.dataset.mrMedia;
      if (el.tagName === 'VIDEO') { el.controls = true; el.autoplay = true; el.playsInline = true; } else { el.alt = ''; }
      content.innerHTML = ''; content.appendChild(el);
      box.hidden = false; document.body.style.overflow = 'hidden';
      var c = box.querySelector('[data-mr-lightbox-close]'); if (c) c.focus();
    });
    if (box) {
      /* Lightbox an body hängen, damit kein Eltern-Element mit transform/overflow sie einsperrt */
      document.body.appendChild(box);
      box.addEventListener('click', function (e) { if (e.target === box || e.target.closest('[data-mr-lightbox-close]')) closeBox(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !box.hidden) closeBox(); });
    }

    readInfo();
  }

  function boot() { document.querySelectorAll('[data-section-type="mate-reviews"]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-section-type="mate-reviews"]')); });
})();
